module.exports = __webpack_public_path__ + "img/credential-text-niice.3736282ea795fcebcbb9593f16d694a5.svg";